import { IotsUptimeWeekdayHeatmapChart, hasChartSeries } from '@frontend/chart/components';
import { FormattedMessage } from 'react-intl';

import { StatisticsCard } from '../../shared';
import { useLast6MonthsHardwareIotsUptimeWeekdayHeatmapChart } from './use-last-6-months-hardware-iots-uptime-weekday-heatmap-chart';

export interface Last6MonthsHardwareIotsUptimeWeekdayHeatmapChartProps {
    accountId: string;
}

export const Last6MonthsHardwareIotsUptimeWeekdayHeatmapChart = (props: Last6MonthsHardwareIotsUptimeWeekdayHeatmapChartProps) => {
    const { data, isLoading, rangeStart, weekCount } = useLast6MonthsHardwareIotsUptimeWeekdayHeatmapChart(props);

    return (
        <StatisticsCard
            chartKey={IotsUptimeWeekdayHeatmapChart.definition.key}
            title={
                <FormattedMessage
                    id='platform.statistics.hardware.last-6-months-hardware-iots-uptime-weekday-heatmap-chart.title'
                    description='Title of the hardware insights heatmap showing IoT uptime by weekday over the last six months'
                    defaultMessage='Uptime weekday pattern'
                />
            }
            subtitle={
                <FormattedMessage
                    id='platform.statistics.hardware.last-6-months-hardware-iots-uptime-weekday-heatmap-chart.subtitle'
                    description='Subtitle on the hardware uptime weekday heatmap indicating the chart covers the last six months'
                    defaultMessage='Last 6 months'
                />
            }
            isLoading={isLoading}
            hasData={hasChartSeries(data)}>
            {hasChartSeries(data) && data && (
                <div className='mt-auto h-full min-h-0 w-full flex-1'>
                    <IotsUptimeWeekdayHeatmapChart
                        data={data}
                        rangeStart={rangeStart}
                        weekCount={weekCount}
                        minHeight={220}
                    />
                </div>
            )}
        </StatisticsCard>
    );
};
